var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon, Tabs } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import * as React from 'react';
import { useBreakpointValue } from 'utils/mediaQuery';
import styles from './respondTabs.module.scss';
const tabs = [
    {
        id: 'reply',
        label: 'Answer',
        icon: 'reply',
    },
    {
        id: 'note',
        label: 'Internal Note',
        icon: 'sticky-note',
    },
];
export const RespondTabs = (props) => {
    const { className, onChange, onResize, onTranscriptClick, showSendTranscript, transcriptButtonText, children, value } = props, otherProps = __rest(props, ["className", "onChange", "onResize", "onTranscriptClick", "showSendTranscript", "transcriptButtonText", "children", "value"]);
    const rootClass = classnames(styles.container, className);
    const isSmallOrMediumScreen = useBreakpointValue({ base: true, lg: false });
    return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass, role: "tablist" }, { children: [_jsx("div", Object.assign({ className: styles.leftWrapper }, { children: _jsx(Tabs, { tabs: tabs, onChange: onChange, selectedId: value, tabClassName: classnames({
                        [styles.compactTab]: isSmallOrMediumScreen,
                    }) }) })), _jsx("div", Object.assign({ className: styles.handle, onPointerDown: onResize }, { children: _jsx(Icon, { name: "bars", className: "icon-vertical-fix" }) })), _jsxs("div", Object.assign({ className: styles.rightWrapper }, { children: [showSendTranscript && (_jsx(Button, Object.assign({ onClick: onTranscriptClick, className: styles.sendTranscript, variant: "tertiary" }, { children: typeof transcriptButtonText === 'string'
                            ? transcriptButtonText
                            : 'Send transcript' }))), children] }))] })));
};
